import React from 'react';
import { Link } from 'react-router-dom';

import styles from './Breadcrumb.module.scss';

export interface ICrumb {
    label: string;
    path?: string;
}

interface IProps {
    crumbs: ICrumb[];
}

const Breadcrumb: React.FC<IProps> = (props) => {
  return(
    <div className={styles.Breadcrumb}>
        {props.crumbs.map((c: ICrumb, index: number) => {
            return (<span className={styles.crumb} key={index}>{c.path ? <Link to={c.path}>{c.label}</Link> : c.label}{index < props.crumbs.length - 1 && <span className={styles.separator}>/</span>}</span>);
        })}
    </div>
  );
}

export default Breadcrumb;